(function (angular) {
    'use strict';

    angular.module('Common')
    /**
     *Directive check if children have active link to resources page. If there is no at least one active element would be hide. Might be extended by providing true as a value of attribute to check also for pemissions-required
    */
    .directive('subMenuHide', ["permissionService", function (permissionService) {
        return {
            restrict: 'A',
            link: function (scope, elm, attrs) {
                var check = false;
                if (attrs.subMenuHide) {
                    var elements = elm.find("[permission-required]");
                    for (var i = 0; i < elements.length; i++) {
                        if (permissionService.checkPrivilegeToDisplay(elements[i].getAttribute("permission-required"))) {
                            var subSref = angular.element(elements[i]).find("[ui-sref]");
                            if (subSref.length) {
                                for (var j = 0; j < subSref.length; j++) {
                                    if (permissionService.checkPrivilegeToDisplay(subSref[j].getAttribute("ui-sref"))) {
                                        check = true;
                                    }
                                }
                            }
                            else {
                                check = true;
                            }
                        }

                    }
                }
                var elements = elm.find("[ui-sref]");
                for (var i = 0; i < elements.length; i++) {
                    if (permissionService.checkPrivilegeToDisplay(elements[i].getAttribute("ui-sref"))) {
                        check = true;
                    }

                }
                if (!check) {
                    elm.css('display', 'none');
                }
            }
        };

    }])
    /**
     *Directive check if element have privilege to display (based on state)
        */
    .directive('permissionRequired', ["permissionService", function (permissionService) {
        return {
            restrict: 'A',
            link: function (scope, elm, attrs) {

                if ((attrs.permissionRequired && !permissionService.checkPrivilegeToDisplay(attrs.permissionRequired))) {
                    if (elm.parent().children().length <= 1) {
                        elm.parent().css('display', 'none');
                    }
                    else {
                        elm.css('display', 'none');
                    }
                }
            }
        };

    }])
    /**
     *Directive chceck if link redirect to state that user have permission to display. If no it hide this element (or parent element)
    */
    .directive('uiSref', ["permissionService", function (permissionService) {
        return {
            restrict: 'A',
            link: function (scope, elm, attrs) {

                if ((attrs.uiSref && !permissionService.checkPrivilegeToDisplay(attrs.uiSref))) {
                    if (elm.parent().children().length <= 1) {
                        elm.parent().css('display', 'none');
                    }
                    else {
                        elm.css('display', 'none');
                    }
                }
            }
        };

    }])

    /**
     * Directives bellow allow you to pass permission name
     * e.g. required-permission="apis:w"
     */ 

    /**
     * Directive hiding single link not allowed to display 
     */
    .directive('requiredPermission', ['permissionService', function (permissionService) {
        return {
            restrict: 'A',
            link: function (scope, elm, attrs) {
                if (!permissionService.checkPermission(attrs.requiredPermission)) {
                    elm.css('display', 'none');
                }
            },
        };
    }])
    /**
     * Directive disabling single input if user don't have permission to it
     */
    .directive('isInputPermitted', ['permissionService', function (permissionService) {
        return {
            restrict: 'A',
            link: function (scope, elm, attrs) {
                if (!permissionService.checkPermission(attrs.isInputPermitted)) {
                    elm.attr('disabled', 'disabled');
                }
            }
        };

    }])
    /**
     * Directive disabling single checkbox if user don't have permission to it
     */
    .directive('isCheckboxPermitted', ['permissionService', function (permissionService) {
        return {
            restrict: 'A',
            link: function (scope, elm, attrs) {
                if (!permissionService.checkPermission(attrs.isCheckboxPermitted)) {
                    var children = elm[0].children;
                    for (var i = 0; i < children.length; i++) {
                        angular.element(children[i]).css('cursor', 'not-allowed');
                        if (children[i].nodeName.toLowerCase() == "input") {
                            angular.element(children[i]).attr('disabled', 'disabled');
                        }
                    }
                }
            }
        };

    }]);
})(window.angular);